import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FinanceCalculatorRoutingModule } from './finance-calculator-routing.module';
import { FinanceCalculatorComponent } from './finance-calculator.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// tslint:disable-next-line: max-line-length
import { NbDialogModule, NbWindowModule, NbCardModule, NbCheckboxModule, NbTabsetModule, NbPopoverModule, NbButtonModule, NbInputModule, NbSpinnerModule, NbSelectModule, NbTooltipModule } from '@nebular/theme';
import { ThemeModule } from '../@theme/theme.module';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: '.',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: ',',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.NATURAL,
};
const MODULES = [
  FormsModule,
  NbDialogModule.forChild(),
  NbWindowModule.forChild(),
  NbCardModule,
  NbCheckboxModule,
  NbTabsetModule,
  NbPopoverModule,
  NbButtonModule,
  NbInputModule,
  NbSpinnerModule,
  NbSelectModule,
  NbTooltipModule, ReactiveFormsModule,
];

@NgModule({
  declarations: [FinanceCalculatorComponent],
  imports: [
    CommonModule,
    FinanceCalculatorRoutingModule, MODULES, NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
  ],
  exports: [FinanceCalculatorComponent],
})
export class FinanceCalculatorModule { }
